<template>
  <CurrencyPickerTemplate
    :currencyLabel="$t('common.currency')"
    :currency="currency"
    :currencyList="currency_list"
    @changeCurrency="changeCurrency"
  />
</template>
<script>
import CurrencyPickerTemplate from "./CurrencyPickerTemplate";
import currency_helper from "@libs/util/CurrencyHelper";

import { mapState, mapActions } from "vuex";
export default {
  components: {
    CurrencyPickerTemplate,
  },
  data() {
    return {
      currency_list: currency_helper.getActualCurrencyList(),
    };
  },
  computed: {
    ...mapState("billing", ["currency"]),
  },
  methods: {
    ...mapActions("billing", ["changeCurrency"]),
  },
};
</script>
